// extracted by mini-css-extract-plugin
export default {"head":"AllProductsHead_head__hngy2","col":"AllProductsHead_col__weDfw"};